// Shopify Advanced: the "buy now" button is removed from the theme, every purchase goes through the cart page.

function getVolumeCl(variantTitle) {
  const match = variantTitle?.match(/(\d+)\s*cl/i);
  return match ? Number(match[1]) : 0;
}

function fetchCart() {
  return new Promise(resolve => jQuery.getJSON('/cart.js', resolve));
}

async function addToCartRules(productId, qty, variantTitle, finalProductQty = null) {
  const cart = await fetchCart();
  const { max: maxQteProduct = null } = productRules[productId] || {};
  const { maxItems, maxAmount, maxVolume } = cartRules;
  const productInCart = cart.items.find(i => i.product_id == productId);
  const currentQty = productInCart ? Number(productInCart.quantity) : 0;
  const finalQty = finalProductQty !== null ? Number(finalProductQty) : currentQty + Number(qty);
  const addedQty = finalQty - currentQty;
  const cartVolumeCl = cart.items.reduce((sum, item) => {
    return sum + getVolumeCl(item.variant_title) * item.quantity;
  }, 0);
  let productVolumeCl = getVolumeCl(variantTitle);
  if(finalProductQty) {
    productVolumeCl = getVolumeCl(productInCart.variant_title);
  }
  const finalCartVolumeCl = cartVolumeCl + productVolumeCl * addedQty;
  const finalCartQty = cart.item_count + addedQty;
  const productPrice = productInCart ? productInCart.final_line_price / productInCart.quantity : 0;
  const finalCartAmount = cart.total_price + productPrice * addedQty;
  if (maxQteProduct != null && finalQty > maxQteProduct)
    return window.cartStrings.product_max.replace('[max]', maxQteProduct);
  if (maxItems !== null && finalCartQty > maxItems)
    return window.cartStrings.cart_items_max.replace('[max]', maxItems);
  if (maxAmount !== null && finalCartAmount > maxAmount * 100)
    return window.cartStrings.cart_amount_max.replace('[max]', maxAmount);
  if (maxVolume !== null && finalCartVolumeCl > maxVolume)
    return window.cartStrings.cart_volume_max.replace('[max]', maxVolume);
  return null;
}

async function goCheckoutRules() {
  const cart = await fetchCart();
  let totalItems = 0,
      totalAmount = cart.total_price,
      totalVolumeCl = 0;
  for (const item of cart.items) {
    const pid = item.product_id;
    const qty = Number(item.quantity);
    totalItems += qty;
    totalVolumeCl += getVolumeCl(item.variant_title) * qty;
    if (productRules[pid]) {
      const { min, max } = productRules[pid];
      if (qty > max)
        return window.cartStrings.specific_product_max.replace('[max]', max).replace("[product_name]", item.product_title);
      if (qty < min)
        return window.cartStrings.specific_product_min.replace('[min]', min).replace("[product_name]", item.product_title);
    }
  }

  const { minItems, maxItems, minAmount, maxAmount, minVolume, maxVolume } = cartRules;
  if (minItems !== null && totalItems < minItems)
    return window.cartStrings.checkout_items_min.replace('[min]', minItems);
  if (maxItems !== null && totalItems > maxItems)
    return window.cartStrings.checkout_items_max.replace('[max]', maxItems);
  if (minAmount !== null && totalAmount < minAmount * 100)
    return window.cartStrings.checkout_amount_min.replace('[min]', minAmount);
  if (maxAmount !== null && totalAmount > maxAmount * 100)
    return window.cartStrings.checkout_amount_max.replace('[max]', maxAmount);
  if (minVolume !== null && totalVolumeCl < minVolume)
    return window.cartStrings.checkout_volume_min.replace('[min]', minVolume);
  if (maxVolume !== null && totalVolumeCl > maxVolume)
    return window.cartStrings.checkout_volume_max.replace('[max]', maxVolume);
  return null;
}

async function goBuyNowRules(productId, quantity, price, variantTitle) {
  await fetchCart();
  const qty = Number(quantity);
  const rules = productRules[productId];
  let totalItems = qty;
  let totalVolumeCl = getVolumeCl(variantTitle || "") * qty;
  let totalAmount = price * qty;
  if(rules) {
    if (qty > rules.max)
      return window.cartStrings.product_max.replace('[max]', rules.max);
    if (qty < rules.min)
      return window.cartStrings.product_min.replace('[min]', rules.min);
  }
  const { minItems, maxItems, minAmount, maxAmount, minVolume, maxVolume } = cartRules;
  if (minItems !== null && totalItems < minItems)
    return window.cartStrings.checkout_items_min.replace('[min]', minItems);
  if (maxItems !== null && totalItems > maxItems)
    return window.cartStrings.checkout_items_max.replace('[max]', maxItems);
  if (minAmount !== null && totalAmount < minAmount * 100)
    return window.cartStrings.checkout_amount_min.replace('[min]', minAmount);
  if (maxAmount !== null && totalAmount > maxAmount * 100)
    return window.cartStrings.checkout_amount_max.replace('[max]', maxAmount);
  if (minVolume !== null && totalVolumeCl < minVolume)
    return window.cartStrings.checkout_volume_min.replace('[min]', minVolume);
  if (maxVolume !== null && totalVolumeCl > maxVolume)
    return window.cartStrings.checkout_volume_max.replace('[max]', maxVolume);
  return null;
}

function showRulePopup(message) {
  document.getElementById("rule-popup-message").innerHTML = message;
  document.getElementById("rule-popup").style.display = "flex";
}

document.getElementById("rule-popup-btn").addEventListener("click", () => {
  document.getElementById("rule-popup").style.display = "none";
});

document.getElementById("rule-popup").addEventListener("click", (e) => {
  if (!document.querySelector(".rule-popup-box").contains(e.target)) {
    document.getElementById("rule-popup").style.display = "none";
  }
});

document.addEventListener("submit", async (e) => {
  if (!e.target.matches("#main-cart")) return;
  e.preventDefault();
  const form = e.target;
  const msg = await goCheckoutRules();
  if (msg) {
    showRulePopup(msg);
    return false;
  }
  form.submit();
});



const cartFormSubmit = document.getElementById('cartFormSubmit');
cartFormSubmit && cartFormSubmit.addEventListener("submit", async (e) => {
  // if (!e.target.matches("#main-cart")) return;
  e.preventDefault();
  // const form = e.target;
  const msg = await goCheckoutRules();
  if (msg) {
    showRulePopup(msg);
    return false;
  }
  e.target.submit();
});